import React, { createContext, useState } from "react";

const MyContext = createContext();

export const MyContextProvider = ({ children }) => {
  const [newCustomAttributeDetails, setNewCustomAttributeDetails] = useState({
    name: "",
    key: "",
    format: "",
  });
  const [generatedHTML, setGeneratedHTML] = useState("");

  // const baseUrl= 'https://payin.shreedevs.com';
  // const baseUrl =
  //   process.env.NODE_ENV === "development"
  //     ? "https://uat.anlook.com"
  //     : "https://api.anlook.com";

  // const baseUrl =
  // process.env.NODE_ENV === "development"
  //   ? "https://remittpe.com"
  //   : "https://payinnew.remittpe.com";
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? "https://api.anlook.com"
      : "https://api.anlook.com";
  const baseUrl2 =
    process.env.NODE_ENV === "development"
      ? "https://openapi.shreedevs.com"
      : "https://openApi.anlook.com";
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
    },
  };
  const config2 = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
    },
  };

  const USERNAME = "BUMPPY_SSO_SgLjvARJ5LbX";

  const PASSWORD =
    "tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq";

  return (
    <MyContext.Provider
      value={{
        setNewCustomAttributeDetails,
        newCustomAttributeDetails,
        baseUrl,
        baseUrl2,
        config,
        config2,
        USERNAME,
        PASSWORD,
        generatedHTML, setGeneratedHTML
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default MyContext;